import React, { useMemo, useState } from "react";
import {
  copyText,
  escapeForTsv,
  formatValue,
  getColumns
} from "./tableColumns";

export default function ReportTableCard({ title, data = [], table, wide = false }) {
  const columns = useMemo(() => getColumns(table), [table]);
  const [copyStatus, setCopyStatus] = useState("");

  async function handleCopy() {
    try {
      if (!data.length) {
        setCopyStatus("Sin datos");
        setTimeout(() => setCopyStatus(""), 1600);
        return;
      }

      const headerLine = columns.map((col) => col.label).join("\t");
      const bodyLines = data.map((row) =>
        columns.map((col) => escapeForTsv(row[col.key])).join("\t")
      );

      await copyText([headerLine, ...bodyLines].join("\n"));
      setCopyStatus("Copiado");
      setTimeout(() => setCopyStatus(""), 1600);
    } catch {
      setCopyStatus("Error al copiar");
      setTimeout(() => setCopyStatus(""), 1800);
    }
  }

  return (
    <section className={`table-card report-table-card ${wide ? "report-table-card-wide" : ""}`}>
      <div className="table-toolbar compact-toolbar">
        <div>
          <h3 className="section-title">{title}</h3>
          <p className="section-subtitle">{data.length} registros</p>
        </div>
        <div className="toolbar-inline-actions">
          {copyStatus ? <span className="copy-status">{copyStatus}</span> : null}
          <button className="secondary-button" type="button" onClick={handleCopy}>
            Copiar
          </button>
        </div>
      </div>

      <div className="table-shell report-table-shell">
        <table className="report-table">
          <thead>
            <tr>
              {columns.map((column) => <th key={column.key}>{column.label}</th>)}
            </tr>
          </thead>
          <tbody>
            {data.length ? (
              data.map((row, index) => (
                <tr key={`${row.NUM_CLI ?? "row"}-${index}`}>
                  {columns.map((column) => (
                    <td key={column.key}>{formatValue(column.key, row[column.key])}</td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} className="empty-cell">Sin resultados</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
